import React from "react";
import { ApolloProvider } from "react-apollo";
import ReactDOM from "react-dom";
import { TunnelProvider } from "react-tunnels";
import FlowApp from "./FlowApp";
import RequestPortalApp from "./RequestPortalApp";
import apolloClient from "./api/apollo";
import { CLIENT_DEFAULT, CLIENT_DELOITTE } from "./constants";

const getClient = () => {
    if (window.location.hostname.startsWith("deloittediligence")) {
        return CLIENT_DELOITTE;
    }
    // for development preview
    if (window.location.hash === "#client=deloitte") {
        return CLIENT_DELOITTE;
    }
    return CLIENT_DEFAULT;
};

const Root = () => {
    const App = window.location.pathname.startsWith("/request-portal")
        ? RequestPortalApp
        : FlowApp;

    return (
        <ApolloProvider client={apolloClient}>
            <TunnelProvider>
                <App client={getClient()} />
            </TunnelProvider>
        </ApolloProvider>
    );
};

(async () => {
    ReactDOM.render(<Root />, document.getElementById("root"));
})();
